import {connect} from "react-redux";
import UCDLeadActivityList from "./list";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../../../service/Activity/action";
import {
    userCheckoutDealerLead,
    markAttendancesDealerLead,
    addTaggedAlong,
    getActivityFilter,
    ratingSave
} from "../../../../../../service/Dealer/action";
import {documentUploadUrlPublic} from "../../../../../../service/fileUpload/action";
import {getLeadById} from "../../../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    isCheckoutDetails: state.Dealer.isCheckoutDetails,
    markAttendanceDetails: state.Dealer.markAttendance,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    activityFilter: state.Dealer.activityFilter,
    savedRating: state.Dealer.savedRating,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    leadById:state.Lead.leadById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            userCheckoutDealerLead,
            markAttendancesDealerLead,
            addTaggedAlong,
            getActivityFilter,
            ratingSave,
            documentUploadUrlPublic,
            getLeadById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDLeadActivityList);
